import { _ } from "../../core/polyglot/polyglot.js";
import abstractCustomInvoiceReportDocument from "./abstractCustomInvoiceReportDocument.js";

/**
 * `agedPayablesReportDocument` is an accounting document responsible
 * for displaying invoice groups values based on due dates.
 */
export default abstractCustomInvoiceReportDocument.subclass((that, my) => {
	my.initialize = function (spec) {
		my.super(spec);

		that.title = _("Aged payables");
	};

	my.getReportId = function () {
		return "AgedPayablesPerSupplier";
	};

	my.getFirstColumnName = function () {
		return _("Supplier");
	};

	my.getHelpMessage = function () {
		return _(
			"This report distinguishing open accounts payable based on the length of time an invoice has been outstanding.",
		);
	};
});
